import React, { useEffect, useRef, useState } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory, withRouter } from "react-router-dom"
import {
  Label,
  Input,
  Button,
  Container,
  Card,
  CardBody,
  Modal,
  Table,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
  Alert,
  Row,
  Col,
  InputGroup,
  FormControl,
  InputGroupAddon,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import {
  addTracking,
  deleteTracking,
  editTracking,
  getTrackings,
  resetTrackingFlag,
  saveTrackingKeyword,
  setTrackingPage,
  setTrackingTotalPage,
  getContainers,
  getContainersError,
  resetContainerFlag,
} from "store/actions"
import moment from "moment"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { toast } from "react-toastify"
import AvInput from "availity-reactstrap-validation/lib/AvInput"
import Paginate from "components/Common/Paginate"
import classnames from "classnames"
import Loading from "components/Common/Loading"

const pageSize = 2

const TrackingList = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const paginateRef = useRef(null)
  const keywordRef = useRef(null)
  const {
    trackingList,
    trackingSuccess,
    trackingError,
    loading,
    loadingSubmit,
    keyword,
    page,
    totalPage,
    containers,
    containersError,
    bookingType,
  } = useSelector(state => ({
    trackingList: state.Trackings.trackings,
    trackingSuccess: state.Trackings.success,
    trackingError: state.Trackings.error,
    loading: state.Trackings.loading,
    loadingSubmit: state.Trackings.loadingSubmit,
    keyword: state.Trackings.keyword,
    page: state.Trackings.page,
    totalPage: state.Trackings.totalPage,
    containers: state.Containers.containers,
    containersError: state.Containers.error,
    bookingType: state.Containers.type,
  }))

  const [modelTracking, setModelTracking] = useState({
    uid: "",
    booking_no: "",
    container_no: "",
  })
  const [verifyBookingNo, setVerifyBookingNo] = useState(false)

  // useEffect(() => {
  //   dispatch(getTrackings())
  // }, [])

  useEffect(() => {
    if (containers.length > 0) setVerifyBookingNo(true)
  }, [containers])

  useEffect(() => {
    dispatch(resetTrackingFlag())
  }, [containersError])

  useEffect(() => {
    if (trackingSuccess) {
      const bookingNo = modelTracking.booking_no
      const containerNo = modelTracking.container_no
      toast.dismiss()
      toast.success(trackingSuccess)
      resetTracking()
      dispatch(resetTrackingFlag())
      if (!modelTracking.uid) {
        history.push(
          `/edit-tracking/?bookingNo=${bookingNo}&containerNo=${containerNo}`
        )
      } else {
        setModalTracking(false)
        setModalConfirmDelete(false)
        dispatch(getTrackings())
      }
    }
  }, [trackingSuccess])

  function onSearch(keywordValue) {
    dispatch(saveTrackingKeyword(keywordValue))
    dispatch(setTrackingPage(1))
    dispatch(getTrackings(1, keywordValue))
  }

  function clearSearch() {
    keywordRef.current.value = ""
    dispatch(saveTrackingKeyword(""))
    dispatch(setTrackingPage(1))
    dispatch(getTrackings(1, ""))
  }

  const [modalTracking, setModalTracking] = useState(false)
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false)

  function toggleModalTracking() {
    resetTracking()
    dispatch(resetTrackingFlag())
    setModalTracking(!modalTracking)
  }

  function toggleModalConfirmDelete() {
    resetTracking()
    dispatch(resetTrackingFlag())
    setModalConfirmDelete(!modalConfirmDelete)
  }

  function handleDelete(tracking) {
    toggleModalConfirmDelete()
    setModelTracking(tracking)
  }

  function handleDeleteSubmit() {
    dispatch(deleteTracking(modelTracking))
  }

  function resetTracking() {
    setModelTracking({
      uid: "",
      booking_no: "",
      container_no: "",
    })
    dispatch(resetContainerFlag())
    setVerifyBookingNo(false)
  }

  function handleFormSubmit(event, values) {
    if (modelTracking.uid === "") {
      dispatch(addTracking({ ...modelTracking, type: bookingType }))
    } else {
      dispatch(editTracking(modelTracking))
    }
  }

  function handleEditTracking(tracking) {
    dispatch(getContainers(tracking.booking_no))
    setModelTracking({ ...tracking })
    setModalTracking(true)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Hast | Tracking List</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex flex-wrap mt-2 mb-3">
            <h4 className="">Tracking List</h4>

            <div className="ms-auto">
              <Button
                color="primary"
                outline
                className=""
                onClick={() => {
                  toggleModalTracking()
                }}
                data-toggle="modal"
                data-target=".bs-example-modal-center"
              >
                Create Tracking
              </Button>
              <Modal isOpen={modalTracking} centered={true}>
                <div className="modal-header">
                  <h5 className="modal-title mt-0">
                    {modelTracking.uid
                      ? " Edit Tracking List "
                      : " Create Tracking List"}
                  </h5>
                  <button
                    type="button"
                    onClick={() => {
                      setModalTracking(false)
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    disabled={loadingSubmit}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {containersError && (
                    <Alert color="danger">{containersError}</Alert>
                  )}

                  {!containersError && trackingError && (
                    <Alert color="danger">{trackingError}</Alert>
                  )}

                  <AvForm
                    className="form-horizontal"
                    // onValidSubmit={(e, v) => {
                    //   handleValidSubmit(e, v)
                    // }}
                  >
                    <div className="mb-2">
                      <Label htmlFor="input-booking-no">
                        Booking No.{" "}
                        <small className="text-muted ">
                          (BookingIn/BookingOut)
                        </small>
                      </Label>
                      <InputGroup className="mb-3">
                        <Input
                          type="text"
                          id="input-booking-no"
                          value={modelTracking.booking_no || ""}
                          placeholder="Enter booking no."
                          onChange={e => {
                            setModelTracking({
                              ...modelTracking,
                              booking_no: e.target.value,
                              container_no: "",
                            })
                            setVerifyBookingNo(false)
                          }}
                        />
                        <InputGroupAddon addonType="append">
                          <Button
                            color={verifyBookingNo ? "success" : "danger"}
                            disabled={verifyBookingNo}
                            onClick={() => {
                              if (modelTracking.booking_no)
                                dispatch(
                                  getContainers(modelTracking.booking_no)
                                )
                              else
                                dispatch(
                                  getContainersError("This booking not found.")
                                )
                            }}
                          >
                            {verifyBookingNo ? "Verified" : "Verify"}
                          </Button>
                        </InputGroupAddon>
                      </InputGroup>

                      {/* <Input
                        type="text"
                        className="form-control"
                        placeholder="Enter booking no."
                        id="input-booking-no"
                        value={modelTracking.booking_no || ""}
                        onChange={e => {
                          setModelTracking({
                            ...modelTracking,
                            booking_no: e.target.value,
                          })
                        }}
                      /> */}
                    </div>
                    <div className="mb-2">
                      <AvField
                        type="select"
                        name="input-container-no"
                        label="Container No."
                        value={modelTracking.container_no}
                        disabled={!verifyBookingNo}
                        onChange={e =>
                          setModelTracking({
                            ...modelTracking,
                            container_no: e.target.value,
                          })
                        }
                      >
                        <option value="">Please select container no.</option>
                        {containers.map((item, i) => (
                          <option key={i} value={item.ContainerName}>
                            {item.ContainerName}
                          </option>
                        ))}
                      </AvField>
                    </div>
                  </AvForm>
                </div>
                <div className="modal-footer">
                  <div className="row w-100">
                    <div className="col-6">
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => {
                          toggleModalTracking()
                        }}
                        disabled={loadingSubmit}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-6 text-end">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={loadingSubmit || !verifyBookingNo}
                        onClick={() => handleFormSubmit()}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
          <AvForm
            className="row mb-3  align-items-center"
            onValidSubmit={(e, v) => onSearch(v.keyword)}
          >
            <Col className="pe-0">
              <div className="search-box" style={{ width: "100%" }}>
                <div className="position-relative">
                  <AvInput
                    type="text"
                    name="keyword"
                    ref={keywordRef}
                    className="form-control rounded"
                    placeholder="Search..."
                    value={keyword || ""}
                    disabled={loading}
                  />
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
              </div>
            </Col>
            <Col>
              <Button
                color="primary"
                className="me-1"
                type="submit"
                disabled={loading}
              >
                Search
              </Button>
              <Button
                type="button"
                color="secondary"
                outline
                onClick={() => clearSearch()}
                disabled={loading}
              >
                Clear
              </Button>
            </Col>
          </AvForm>
          <>
            <Card>
              <CardBody>
                <div
                  className="table-responsive file-manager"
                  style={{ overflowX: "visible", overflowY: "visible" }}
                >
                  <Table className="table align-middle table-nowrap table-hover mb-0">
                    <thead>
                      <tr className="text-center">
                        <th
                          scope="col"
                          width="5%"
                          className="d-none d-md-table-cell"
                        >
                          Type
                        </th>
                        <th scope="col" width="25%">
                          Booking No.
                        </th>
                        <th scope="col" width="25%">
                          Container No.
                        </th>
                        <th scope="col" className="d-none  d-lg-table-cell">
                          Created At
                        </th>
                        <th width="10%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={5}>
                            <Loading />
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {trackingList.length === 0 && (
                            <tr style={{ textAlign: "center" }}>
                              <td colSpan="5">Not found tracking data.</td>
                            </tr>
                          )}
                          {trackingList.length > 0 &&
                            trackingList.map((tracking, key) => (
                              <tr key={key}>
                                <td className="text-center d-none d-md-table-cell">
                                  <small
                                    style={{
                                      width: "50px",
                                    }}
                                    className={classnames("badge py-2", {
                                      "bg-success": tracking.type === "in",
                                      "bg-warning": tracking.type === "out",
                                    })}
                                  >
                                    {tracking.type.toUpperCase()}
                                  </small>
                                </td>
                                <td className="text-center">
                                  <small className="d-sm-none">
                                    {tracking.booking_no}
                                  </small>
                                  <span className="d-none d-sm-inline">
                                    {tracking.booking_no}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <small className="d-sm-none">
                                    {tracking.container_no}
                                  </small>
                                  <span className="d-none d-sm-inline">
                                    {tracking.container_no}
                                  </span>
                                </td>
                                <td className="text-center d-none d-lg-table-cell">
                                  {moment(tracking.created_at).format(
                                    "DD-MM-YYYY HH:mm:ss"
                                  )}
                                </td>
                                <td className="text-center">
                                  <UncontrolledDropdown direction="left">
                                    <DropdownToggle
                                      color="white"
                                      className="btn font-size-16 btn-link text-muted mt-n2"
                                    >
                                      <i className="mdi mdi-dots-horizontal"></i>
                                    </DropdownToggle>

                                    <DropdownMenu className="dropdown-menu-end">
                                      <Link
                                        to={`/edit-tracking?bookingNo=${tracking.booking_no}&containerNo=${tracking.container_no}`}
                                        className="dropdown-item"
                                      >
                                        Edit
                                      </Link>
                                      <Link
                                        to={`/view-tracking?bookingNo=${tracking.booking_no}&containerNo=${tracking.container_no}`}
                                        className="dropdown-item"
                                      >
                                        View
                                      </Link>
                                      <div className="dropdown-divider"></div>
                                      <DropdownItem
                                        className="dropdown-item"
                                        onClick={() => handleDelete(tracking)}
                                      >
                                        Delete
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </td>
                              </tr>
                            ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                </div>
                <Paginate
                  ref={paginateRef}
                  page={page}
                  totalPage={totalPage}
                  pageSize={pageSize}
                  onSetPage={value => dispatch(setTrackingPage(value))}
                  onSetTotalPage={value =>
                    dispatch(setTrackingTotalPage(value))
                  }
                  onPageChange={pageValue =>
                    dispatch(getTrackings(pageValue, keyword))
                  }
                  dataList={trackingList}
                  globalTotalPage
                  loading={loading}
                />
              </CardBody>
            </Card>
            <Modal isOpen={modalConfirmDelete} centered={true}>
              <div className="modal-header">
                <h5 className="modal-title mt-0">Confirm Delete</h5>
                <button
                  type="button"
                  onClick={() => {
                    setModalConfirmDelete(false)
                  }}
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  disabled={loadingSubmit}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {trackingError ? (
                  <Alert color="danger">{trackingError}</Alert>
                ) : null}

                <Row
                  className="mb-3 mt-3 ms-0 me-0"
                  style={{ wordWrap: "break-word", wordBreak: "break-all" }}
                >
                  <Col>
                    <span className="font-weight-light">Booking No.</span>
                    <h4>{modelTracking.booking_no || ""}</h4>
                  </Col>
                  <Col>
                    <span className="font-weight-light">Container No.</span>
                    <h4>{modelTracking.container_no || ""}</h4>
                  </Col>
                </Row>
              </div>
              <div className="modal-footer">
                <div className="row w-100">
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => {
                        toggleModalConfirmDelete()
                      }}
                      disabled={loadingSubmit}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="col-6 text-end">
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDeleteSubmit()}
                      disabled={loadingSubmit}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(TrackingList)
